import axios from "axios";
// import qs from "qs";
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  ActivitytempApi: root + "/Sellgoal/ActivitytempApi",
  ActivitytempOneApi: root + "/Sellgoal/ActivitytempOneApi",
  getFrommediaApi: root + "/Sellgoal/getFrommediaApi",
  getGroundPromotion: root + "/Sellgoal/getGroundPromotion",
  ActivityCoursecatApi: root + "/PhoneActivity/ActivityCoursecatApi",
  activityPackageListApi: root + "/Sellgoal/activityPackageListApi",
};
const storeActive = {
  activityPackageListApi(params) {
    return axios.get(url.activityPackageListApi, { params });
  },
  ActivitytempApi(params) {
    return axios.get(url.ActivitytempApi, { params });
  },
  ActivityCoursecatApi(params) {
    return axios.get(url.ActivityCoursecatApi, { params });
  },
  //招生目标->单个招生模板的信息
  ActivitytempOneApi(params) {
    return axios.get(url.ActivitytempOneApi, { params });
  },
  // 获取渠道来源
  getFrommediaApi(params) {
    return axios.get(url.getFrommediaApi, { params });
  },
  getGroundPromotion(params) {
    return axios.get(url.getGroundPromotion, { params });
  },
  // 招生目标线索->绑定学员
  // bindingClient(params) {
  //   return axios.post(url.bindingClient, qs.stringify(params));
  // }
};

export default storeActive;
